<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('b2b_partners')" icon="briefcase">
            <app-default-button @click="openModal()" v-if="$can('create_customers')"
                :title="$fieldTitle('add', 'b2b_partner', true)" />
        </app-page-top-section>

        <app-table v-if="options.url" :id="table_id" :options="options" @action="triggerActions" />

        <app-b2b-partner-modal v-if="isModalActive" v-model="isModalActive" :selected-url="selectedUrl"
            @close="isModalActive = false" />

        <app-b2b-partner-pricelist-modal v-if="isPricelistActive" v-model="isPricelistActive" :partner="pricelistPartner"
            @close="isPricelistActive = false" />

        <app-confirmation-modal v-if="confirmationModalActive" icon="trash-2" modal-id="app-confirmation-modal"
            @confirmed="confirmed('b2b-partners-table')" @cancelled="cancelled" />
    </div>
</template>

<script>
import HelperMixin from "../../../../common/Mixin/Global/HelperMixin";
import B2bPartnerMixin from "../../Mixins/B2bPartnerMixin";
import CoreLibrary from "../../../../core/helpers/CoreLibrary";
import { B2B_PARTNERS } from "../../../Config/ApiUrl-CPB";

export default {
    name: "B2bPartner",
    mixins: [HelperMixin, B2bPartnerMixin],
    extends: CoreLibrary,
    data() {
        return {
            table_id: 'b2b-partners-table',
            isModalActive: false,
            selectedUrl: '',
            isPricelistActive: false,
            pricelistPartner: {},
        }
    },
    methods: {
        triggerActions(row, action, active) {
            if (action.title === this.$t('edit')) {
                this.selectedUrl = `${B2B_PARTNERS}/${row.id}`;
                this.isModalActive = true;
            } else if (action.title === this.$t('Pricelist')) {
                this.pricelistPartner = row;
                this.isPricelistActive = true;
            } else {
                this.getAction(row, action, active);
            }
        },
        openModal() {
            this.isModalActive = true;
            this.selectedUrl = '';
        },
    }
}
</script>
